"use client";

import React from "react";
import { Phone, Navigation, Zap, Truck } from "lucide-react";
import { Link } from "@/components/common/Link";
const HERO_IMAGE = "https://upward-sunbeam.10web.cloud/wp-content/uploads/2026/05/hero-4.png";
const GOOGLE_REVIEW_LINK = "https://www.google.com/maps/place/Nova+Tire+Center/@34.0542974,-118.3797393,17z/data=!4m8!3m7!1s0x80c2b9434ecdbaa1:0x8ff20ca23b3c94c4!8m2!3d34.0542974!4d-118.3797393!9m1!1b1!16s%2Fg%2F11vwy3ylgz?authuser=0&hl=en&entry=ttu&g_ep=EgoyMDI2MDkwOS4wIKXMDSoASAFQAw%3D%3D";
const YELP_REVIEW_LINK = "https://www.yelp.com/writeareview/biz/0FtPEoz4hY7Pq_kCq-ccaw?return_url=%2Fbiz%2F0FtPEoz4hY7Pq_kCq-ccaw&review_origin=biz-details-war-button";
export default function NovaHeroPremiumFinal() {
  return <section className="relative overflow-hidden bg-white">
      {}
      <div className="absolute inset-0 z-0">
        <img src={HERO_IMAGE} alt="Nova Tire Center tire service" className="w-full h-full object-cover object-[72%_center] md:object-[78%_center]" />

        <div className="absolute inset-0 bg-gradient-to-b from-white/84 via-white/62 to-black/16 md:hidden" />

        <div className="hidden md:block absolute inset-0 bg-gradient-to-r from-white from-[0%] via-white/80 via-[26%] via-white/30 via-[42%] to-transparent to-[60%]" />

        <div className="absolute inset-0 bg-gradient-to-b from-white/5 via-transparent to-black/10" />
      </div>

      {}
      <div className="absolute z-10 left-[46%] top-0 h-full w-[12px] bg-[#0B4DBA]/95 -skew-x-[13deg] hidden lg:block" />
      <div className="absolute z-10 left-[45%] top-[40px] h-[300px] w-[9px] bg-[#FF5A00]/90 -skew-x-[13deg] hidden lg:block" />
      <div className="absolute z-10 left-[46.9%] top-0 h-full w-[3px] bg-white/50 -skew-x-[13deg] hidden lg:block" />

      {}
      <div className="relative z-20 max-w-[1180px] mx-auto px-4 lg:px-6">
        <div className="min-h-[520px] md:min-h-[470px] flex items-start md:items-center">
          <div className="max-w-[520px] ml-0 lg:ml-[-70px] pt-14 pb-10 md:py-8">
            {}
            <div className="inline-flex items-center gap-2 bg-white/92 border border-[#DDE7F5] px-4 md:px-5 py-2.5 md:py-3 mb-5">
              <Zap className="w-4 h-4 text-[#0B4DBA]" />
              <span className="text-[#0B4DBA] text-[11px] md:text-[13px] font-black uppercase tracking-[0.04em]">
                Fast. Reliable. Local.
              </span>
            </div>

            {}
            <h1 className="uppercase italic tracking-[-0.055em] leading-[0.86]">
              <span className="block text-black font-black text-[66px] sm:text-[72px] md:text-[92px] lg:text-[100px]">
                Fast
              </span>

              <span className="block text-[#0B4DBA] font-black text-[36px] sm:text-[40px] md:text-[52px] lg:text-[58px] drop-shadow-[2px_2px_0px_rgba(0,0,0,0.92)] mt-1">
                Tire Service
              </span>

              <span className="block text-black font-black text-[22px] sm:text-[24px] md:text-[28px] lg:text-[31px] tracking-[0.05em] mt-2 md:mt-3 not-italic">
                Los Angeles
              </span>
            </h1>

            {}
            <div className="w-[74px] md:w-[84px] h-[3px] md:h-[4px] bg-[#FF5A00] mt-5 mb-10 md:mb-6" />

            {}
            <div className="mt-0 flex flex-col gap-3 w-full max-w-[310px]">
              <a href="tel:+14243138474" className="inline-flex items-center justify-center gap-2.5 bg-gradient-to-b from-[#FF7A2F] to-[#E94E00] hover:from-[#FF8642] hover:to-[#D94400] text-white px-5 md:px-8 py-[14px] md:py-[16px] w-full font-black uppercase text-[15px] md:text-[16px] rounded-xl border border-white/40 shadow-[0_8px_18px_rgba(171,55,0,.28),inset_0_1px_0_rgba(255,255,255,.38)] hover:-translate-y-0.5 hover:shadow-[0_11px_22px_rgba(171,55,0,.34),inset_0_1px_0_rgba(255,255,255,.42)] transition-all duration-200">
                <Phone className="w-4 h-4" />
                Call Now
              </a>

              <Link to="https://www.google.com/maps/dir/?api=1&destination=34.05439451680097%2C-118.37986175094777" newTab className="inline-flex items-center justify-center gap-2.5 bg-gradient-to-b from-white to-[#EFF4FB] text-[#0B4DBA] hover:from-[#F9FBFF] hover:to-[#E5EEF9] px-5 md:px-8 py-[14px] md:py-[16px] w-full font-black uppercase text-[15px] md:text-[16px] rounded-xl border border-[#8BAFDD] shadow-[0_7px_16px_rgba(11,77,186,.16),inset_0_1px_0_rgba(255,255,255,.90)] hover:-translate-y-0.5 hover:border-[#0B4DBA] hover:shadow-[0_10px_20px_rgba(11,77,186,.22),inset_0_1px_0_rgba(255,255,255,.95)] transition-all duration-200">
                <Navigation className="w-4 h-4" />
                Get Directions
              </Link>

              <Link to="https://novatirecenter.com/mobile-tire-service-los-angeles/" newTab className="mt-4 inline-flex items-center justify-center gap-3 bg-gradient-to-b from-[#123E75] via-[#0A2D59] to-[#061B3A] hover:from-[#174A88] hover:via-[#0D3567] hover:to-[#061B3A] text-white px-5 md:px-8 py-[17px] md:py-[19px] w-full font-black uppercase rounded-2xl border border-[#FF8A45]/70 shadow-[0_12px_26px_rgba(6,27,58,.35),0_3px_0_#FF6A1A,inset_0_1px_0_rgba(255,255,255,.20)] hover:-translate-y-1 hover:shadow-[0_16px_30px_rgba(6,27,58,.42),0_3px_0_#FF6A1A,inset_0_1px_0_rgba(255,255,255,.24)] transition-all duration-200">
                <span className="flex h-10 w-10 md:h-11 md:w-11 shrink-0 items-center justify-center rounded-full bg-[#FF6A1A] shadow-[inset_0_1px_0_rgba(255,255,255,.45),0_5px_12px_rgba(0,0,0,.28)]"><Truck className="w-5 h-5 md:w-6 md:h-6" /></span>
                                <span className="flex flex-col items-start leading-none"><span className="text-[9px] md:text-[10px] tracking-[0.18em] text-white/75">NEED US TO COME TO YOU?</span><span className="mt-1 text-[20px] md:text-[23px] tracking-[0.035em]">MOBILE SERVICE</span><span className="mt-1.5 text-[9px] md:text-[10px] tracking-[0.17em] text-[#FFB27D]">PRESS HERE • NOW AVAILABLE</span></span>
              </Link>
            </div>
          </div>
        </div>
      </div>

      {}
      <div className="hidden md:block relative z-30 bg-[#F7F9FC] border-t border-[#E3E7EF]">
        <div className="max-w-[1180px] mx-auto px-6 py-4">
          <div className="flex items-center justify-center gap-0 max-w-[760px] mx-auto bg-white border border-[#E3E7EF] rounded-md overflow-hidden">
            {}
            <a href={GOOGLE_REVIEW_LINK} target="_blank" rel="noopener noreferrer" className="flex-1 flex flex-col items-center justify-center text-center py-4 transition hover:bg-[#F7F9FC]">
              <div className="flex items-center gap-1.5">
                <span className="text-[#0B4DBA] font-black text-[22px]">G</span>
                <span className="text-black font-black text-[16px]">4.9</span>
                <span className="text-[#FFB400] text-[14px]"></span>
              </div>
              <span className="text-[11px] text-[#5B6575] font-semibold uppercase tracking-wide mt-1">
                Google Reviews
              </span>
            </a>

            <div className="w-px h-[44px] bg-[#D7DFEC]" />

            {}
            <div className="flex-1 flex flex-col items-center justify-center text-center py-4">
              <div className="text-black font-black text-[16px] leading-none">
                Top 3
              </div>
              <span className="text-[11px] text-[#5B6575] font-semibold uppercase tracking-wide mt-1">
                Tire Shop
              </span>
              <span className="text-[10px] text-[#5B6575] uppercase">
                Central LA
              </span>
            </div>

            <div className="w-px h-[44px] bg-[#D7DFEC]" />

            {}
            <Link to={YELP_REVIEW_LINK} newTab className="flex-1 flex flex-col items-center justify-center text-center py-4 transition hover:bg-[#F7F9FC]">
              <div className="flex items-center gap-1.5">
                <span className="text-[#FF5A00] font-black text-[22px]">Y</span>
                <span className="text-black font-black text-[16px]">4.8</span>
                <span className="text-[#FFB400] text-[14px]"></span>
              </div>
              <span className="text-[11px] text-[#5B6575] font-semibold uppercase tracking-wide mt-1">
                Yelp Reviews
              </span>
            </Link>
          </div>
        </div>
      </div>

      {}
      <div className="relative z-30 bg-[#F7F9FC] border-t border-[#E3E7EF] md:hidden">
        <div className="flex items-center justify-between gap-2 px-3 py-4">
          {}
          <a href={GOOGLE_REVIEW_LINK} target="_blank" rel="noopener noreferrer" className="flex flex-col items-center text-center min-w-0 flex-1 transition duration-200 hover:opacity-80 hover:-translate-y-[1px]">
            <div className="flex items-center gap-1">
              <span className="text-[#0B4DBA] font-black text-[20px]">G</span>
              <span className="text-black font-black text-[14px]">4.9</span>
              <span className="text-[#FFB400] text-[12px]"></span>
            </div>
            <span className="text-[10px] text-[#5B6575] font-semibold uppercase tracking-wide mt-1">
              Google Reviews
            </span>
          </a>

          <div className="w-px h-[36px] bg-[#D7DFEC]" />

          {}
          <div className="flex flex-col items-center text-center min-w-0 flex-1">
            <div className="text-black font-black text-[14px] leading-none">
              Top 3
            </div>
            <span className="text-[10px] text-[#5B6575] font-semibold uppercase tracking-wide mt-1">
              Tire Shop
            </span>
            <span className="text-[9px] text-[#5B6575] uppercase">
              Central LA
            </span>
          </div>

          <div className="w-px h-[36px] bg-[#D7DFEC]" />

          {}
          <Link to={YELP_REVIEW_LINK} newTab className="flex flex-col items-center text-center min-w-0 flex-1 transition duration-200 hover:opacity-80 hover:-translate-y-[1px]">
            <div className="flex items-center gap-1">
              <span className="text-[#FF5A00] font-black text-[20px]">Y</span>
              <span className="text-black font-black text-[14px]">4.8</span>
              <span className="text-[#FFB400] text-[12px]"></span>
            </div>
            <span className="text-[10px] text-[#5B6575] font-semibold uppercase tracking-wide mt-1">
              Yelp Reviews
            </span>
          </Link>
        </div>
      </div>
    </section>;
}